import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import {
  BillerSubAccountDelegateConfirmationDialogComponent,
} from './biller-sub-account-delegate-confirmation-dialog/biller-sub-account-delegate-confirmation-dialog.component';
import { CreditCardInfoDialogComponent } from './components/credit-card-info-dialog/credit-card-info-dialog.component';
import {
  OfferDetailsDialogEntryComponent,
} from './containers/offer-details-entry/offer-details-dialog-entry.component';
import {
  XsellConsentDialogEntryComponent,
} from './containers/xsell-consent-dialog-entry/xsell-consent-dialog-entry.component';
import {
  XsellOfferDetailsDialogEntryComponent,
} from './containers/xsell-offer-details-entry/xsell-offer-details-dialog-entry.component';
import {
  DeleteBillerSubAccountDelegationConfirmationDialogComponent,
} from './delete-biller-sub-account-delegation-confirmation-dialog/delete-biller-sub-account-delegation-confirmation-dialog.component';
import {
  DeleteLiabilityDelegationConfirmationDialogComponent,
} from './delete-liability-delegation-confirmation-dialog/delete-liability-delegation-confirmation-dialog.component';
import {
  LiabilityDelegateConfirmationDialogComponent,
} from './liability-delegate-confirmation-dialog/liability-delegate-confirmation-dialog.component';
import { PhoneNumberEditDialogComponent } from './phone-number-edit-dialog/phone-number-edit-dialog.component';
import { UnverifiedCustomerDialogComponent } from './unverified-customer-dialog/unverified-customer-dialog.component';
import {
  DelegatedLiabilityStartedDialogComponent,
} from './delegated-liability-started/delegated-liability-started-dialog.component';
import {
  ExpressPaymentUnavailableDialogComponent,
} from '../pay/components/express-payment-unavailable-dialog/express-payment-unavailable-dialog.component';
import {
  MixedCartClearanceQuestionDialogComponent,
} from './mixed-cart-clearance-question-dialog/mixed-cart-clearance-question-dialog.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ApiCallLoadingDirective } from '../shared/directives/api-call-loading.directive';


@NgModule({
  declarations: [
    XsellConsentDialogEntryComponent,
    OfferDetailsDialogEntryComponent,
    CreditCardInfoDialogComponent,
    XsellOfferDetailsDialogEntryComponent,
    PhoneNumberEditDialogComponent,
    UnverifiedCustomerDialogComponent,
    LiabilityDelegateConfirmationDialogComponent,
    BillerSubAccountDelegateConfirmationDialogComponent,
    DeleteLiabilityDelegationConfirmationDialogComponent,
    DeleteBillerSubAccountDelegationConfirmationDialogComponent,
    DelegatedLiabilityStartedDialogComponent,
    ExpressPaymentUnavailableDialogComponent,
    MixedCartClearanceQuestionDialogComponent,
  ],
  exports: [
    XsellConsentDialogEntryComponent,
    OfferDetailsDialogEntryComponent,
    CreditCardInfoDialogComponent,
    XsellOfferDetailsDialogEntryComponent,
    PhoneNumberEditDialogComponent,
    UnverifiedCustomerDialogComponent,
    LiabilityDelegateConfirmationDialogComponent,
    BillerSubAccountDelegateConfirmationDialogComponent,
    DeleteLiabilityDelegationConfirmationDialogComponent,
    DeleteBillerSubAccountDelegationConfirmationDialogComponent,
    DelegatedLiabilityStartedDialogComponent,
    ExpressPaymentUnavailableDialogComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective, NgxMaskPipe, ApiCallLoadingDirective,
  ],
  providers: [provideNgxMask()],
})

export class SharedDialogsModule {

}
